module.exports = __webpack_public_path__ + "media/packs/images/flags/PA-535f1240753dad2d1850db8fad7a0f44.png";